import { Component } from '@angular/core';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { ConstantsService } from '../../constants/constants.service';
import { HttpService } from '../../services/http.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { VisitUpdateService } from '../../services/VisitUpdateService';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, RouterLink, FormsModule, CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  host: { id: 'sidebar' },
})
export class SidebarComponent {
  VisitStatusCounts: any[] = [];
  AllVisitorStatusCounts: any = {};
  private visitUpdateSubscription: Subscription = new Subscription();
  roleName: string = '';
  user: any;
  openScanner: boolean = false;

  constructor(
    public constants: ConstantsService,
    private router: Router,
    private httpService: HttpService,
    private toastr: ToastrService,
    private visitUpdateService: VisitUpdateService
  ) {}
  ngOnInit(): void {
    const storage = this.constants.getSession();
    console.log('Storge:', storage);
    if (storage) {
      this.roleName = storage.role.name;
    }
    // this.getVisitStatusCounts();
    // this.getALLVisitorCounts();
   

    // Subscribe to visit update events
    this.visitUpdateSubscription =
      this.visitUpdateService.visitUpdated$.subscribe(() => {
        // this.getVisitStatusCounts();
        // this.getALLVisitorCounts();
      });
    
    this.user = this.constants.getSession();
    this.roleName = this.user.role.name;
  }
  ngOnDestroy(): void {
    // Clean up subscription when component is destroyed
    if (this.visitUpdateSubscription) {
      this.visitUpdateSubscription.unsubscribe();
    }
  }
  /*
  getVisitStatusCounts(): void {
    this.httpService
      .getRequest(this.constants.SERVER_URLS['VISITS_STATUS_COUNT'])
      .subscribe((res: any) => {
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          this.VisitStatusCounts = res.result;
          console.log('======>', res.result);
        } else {
          this.toastr.error(res.message, 'Error');
        }
      });
  }
  getALLVisitorCounts(): void {
    this.httpService
      .getRequest(this.constants.SERVER_URLS['ALL_VISITORS_COUNT'])
      .subscribe((res: any) => {
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          this.AllVisitorStatusCounts = res.result;
          console.log('======>', res.result);
        } else {
          this.toastr.error(res.message, 'Error');
        }

      });
  }


 getCount(status: string): number {
  if (status === 'Scheduled') {
    const scheduled = this.VisitStatusCounts.find((s: any) => s.status === 'Scheduled');
    const checkedIn = this.VisitStatusCounts.find((s: any) => s.status === 'Checked_In');
    const scheduledCount = scheduled ? scheduled.count : 0;
    const checkedInCount = checkedIn ? checkedIn.count : 0;
    return scheduledCount + checkedInCount;
  }

  const item = this.VisitStatusCounts.find((s: any) => s.status === status);
  return item ? item.count : 0;
}

*/

  logout() {
    this.constants.clearSession();
    this.router.navigate(['/login']);
    this.closeSidebar();
  }
  closeSidebar() {
    const wrapper = document.getElementById('main-wrapper');
    if (wrapper) {
      wrapper.classList.remove('show-sidebar');
    }
  }
  viewVisitsByStatus(status: string) {
    this.closeSidebar();
    this.router.navigate(['visit-list'], {
      queryParams: {
        status: status,
      },
    });
  }
   viewManageVisits(status: string) {
    this.closeSidebar();
    this.router.navigate(['visit-list'], {
      queryParams: {
        status: status,
      },
    });
  }

   handleScan(event: any) {
  const result = event?.detail?.result;
  if (result) {
    console.log('Scanned from header:', result);
  }
  this.openScanner = false;
}
}
